/* eslint-disable max-lines-per-function */

import { useEffect, useLayoutEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';

import './index.scss';
import { getCountryFromIp } from '@/apis/common';
import { init } from '@/utils/common';
import { getLanguage, useI18n } from '@/utils/i18next';
import { detectDevice } from '@/utils/tool';

function Download() {
    const { t } = useI18n();
    const language = getLanguage();
    const [top, setTop] = useState(168);
    const [imgStyle, setImgStyle] = useState({ height: 549 });
    const device = detectDevice();
    const isZh = language?.toLocaleLowerCase()?.indexOf('zh') > -1;
    useEffect(() => {
        init();
    }, []);
    useLayoutEffect(() => {
        const img = document.getElementsByClassName('img')[0];
        if (img) {
            setTop(img.offsetHeight * 0.306);
        }
    });

    const downIOS = async () => {
        window.open('https://apps.apple.com/us/app/yigoli/id6477347755');
    };
    const downAndroid = async () => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const res = await getCountryFromIp();
        window.open(`${res.sourceUrl}/app/YIGOLI/release/YIGOLI.apk`);
    };

    return (
        <div className="home">
            <div className="content">
                <div className="img-box" style={imgStyle}>
                    <img
                        alt=""
                        className="img"
                        onLoad={() => {
                            setImgStyle({});
                        }}
                        src={require('@/assets/images/download/download_bg.jpg')}
                        style={imgStyle}
                    />
                    <div className="text" style={{ top, width: '100%', lineHeight: isZh ? '32px' : undefined }}>
                        <p>
                            <span>{t('pages.download.dowApp3')}</span>
                            <span className="red"> {t('pages.download.app')} </span>
                        </p>
                        <p>{t('pages.download.downloadDesc1')}</p>
                        <p>{t('pages.download.downloadDesc2')}</p>
                    </div>
                </div>
                <div className="btns">
                    {device === 'iOS' ? (
                        <div className="btn" onClick={downIOS}>
                            {t('pages.download.dowApp3')}
                        </div>
                    ) : (
                        <>
                            {' '}
                            <div
                                className="btn"
                                onClick={() => {
                                    window.open('https://play.google.com/store/apps/details?id=com.yigoli.carwashintl');
                                }}
                            >
                                {t('pages.download.dowApp1')}
                            </div>
                            <div className="btn" onClick={downAndroid}>
                                {t('pages.download.dowApp2')}
                            </div>
                        </>
                    )}

                    {/* <div className="btn" onClick={openApp}>
                        {t('pages.download.openApp')}
                    </div> */}
                </div>
            </div>
        </div>
    );
}

export default Download;

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(<Download />);
